import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Select,
  TextInput,
  Title,
} from "@mantine/core";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandMedium,
  IconBuildingWarehouse,
  IconCalendar,
  IconFileExport,
  IconSearch,
  IconTransferIn,
  IconTransferOut,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { BASE_API_DELIVERY } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { DatePickerInput } from "@mantine/dates";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { ReportGeneralInventoryModel } from "../../../model/ReportGeneralInventoryModel";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReportGeneralInventory = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<ReportGeneralInventoryModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [search, setSearch] = useState<any>({
    startDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    endDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const [searchItemCode, setSearchItemCode] = useState<string>("");
  const [debounceSearchItemCode] = useDebouncedValue(searchItemCode, 300);

  const [searchCatSegment4d, setSearchCatSegment4d] = useState("");
  const [debouncedCatSegment4d] = useDebouncedValue(searchCatSegment4d, 500);

  const [searchCatSegment5e, setSearchCatSegment5e] = useState("");
  const [debouncedCatSegment5e] = useDebouncedValue(searchCatSegment5e, 500);
  //select
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataInventorySelect, setDataInventorySelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataItemCodeSelect, setDataItemCodeSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<ReportGeneralInventoryModel>[]>(
    () => [
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue ?? "Không có mã sản phẩm"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" color="violet">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "branchName",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "maKho",
        header: "Mã kho",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" color="blue">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "tenKho",
        header: "Tên kho",
        size: 225,
      },

      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 300,
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
      },
      {
        accessorKey: "segment1Code",
        header: "Mã phân đoạn 1",
      },
      {
        accessorKey: "segment1Name",
        header: "Tên phân đoạn 1",
      },
      {
        accessorKey: "segment6Code",
        header: "Mã phân đoạn 6",
      },
      {
        accessorKey: "segment6Name",
        header: "Tên phân đoạn 6",
      },
      {
        accessorKey: "plvt1Code",
        header: "Mã plvt 1",
      },
      {
        accessorKey: "plvt1Name",
        header: "Tên plvt 1",
      },
      {
        accessorKey: "plvt3Code",
        header: "Mã plvt 3",
      },
      {
        accessorKey: "plvt3Name",
        header: "Tên plvt 3",
      },
      {
        accessorKey: "plvt4Code",
        header: "Mã plvt 4",
      },
      {
        accessorKey: "plvt4Name",
        header: "Tên plvt 4",
      },
      {
        accessorKey: "plvt5Code",
        header: "Mã plvt 5",
      },
      {
        accessorKey: "plvt5Name",
        header: "Tên plvt 5",
      },
      {
        accessorKey: "plvt6Code",
        header: "Mã plvt 6",
      },
      {
        accessorKey: "plvt6Name",
        header: "Tên plvt 6",
      },
      {
        accessorKey: "sumQuantity",
        header: "Tổng số lượng",
      },
      {
        accessorKey: "slChoXuat",
        header: "Số lượng chờ xuất",
        size: 200,
      },
      {
        accessorKey: "slChoNhap",
        header: "Số lượng chờ nhập",
        size: 200,
      },
    ],
    [],
  );

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblInventorySerialOnhand/get-list-overview-onhand-quantity-report?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const res =
        await repositoryDelivery.get<
          MessageResponse<ReportGeneralInventoryModel[]>
        >(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleExportExcel = async () => {
    open();
    try {
      let url = `/api/v1/TblInventorySerialOnhand/export-overview-onhand-quantity-report?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      url += `&${params.toString()}`;

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_ton_kho_tong_quat" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.value?.toString(),
        }));
      setDataBranchSelect(data);
    }
  };

  const fetchDataInventory = async () => {
    const branchSearch = search?.BranchIds.map(
      (item: string) => `&BranchId=${item}`,
    ).join("");

    const take = search?.BranchIds?.length * 20;

    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${take}${branchSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.idBranch && item.name)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.name}`,
          value: item.code?.toString(),
        }));
      setDataInventorySelect(data);
    }
  };

  const fetchDataItem = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblItem/get-list?Skip=0&Take=20&ListItemCode=${searchItemCode}`,
    );

    if (res && res.success) {
      if (
        !dataItemCodeSelect.some(
          (item) =>
            item.value === searchItemCode || item.label === searchItemCode,
        )
      ) {
        const result = res.data
          ?.filter((item: any) => item.itemCode && item.itemName)
          ?.map((item: any) => ({
            label: item.itemCode + " - " + item.itemName,
            value: item.itemCode,
          }));
        const uniqueData = Array.from(
          new Set(result.map((item: any) => item.value)),
        ).map((value) => result.find((item: any) => item.value === value));
        setDataItemCodeSelect([...dataItemCodeSelect, ...uniqueData]);
      }
    }
  };

  const fetchDataCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=30`;

    if (searchCatSegment4d.length > 0) {
      url += `&KeySearch=${searchCatSegment4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  const fetchDataCatSegment5e = async () => {
    let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=30`;

    if (searchCatSegment5e.length > 0) {
      url += `&KeySearch=${searchCatSegment5e}`;
    }

    if (search?.ListMaChung && search?.ListMaChung.length > 0) {
      url += `&ListCodeString4=${search.ListMaChung.join(",")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment5e(dataAPI);
    }
  };

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem(
        "reportGeneralInvColumnPinning",
      );
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : {
            left: ["mrt-row-select", "mrt-row-numbers", "maSp"],
            right: ["slChoXuat", "slChoNhap"],
          }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return {
        left: ["mrt-row-select", "mrt-row-numbers", "maSp"],
        right: ["slChoXuat", "slChoNhap"],
      };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem(
        "reportGeneralInvColumnPinning",
        JSON.stringify(columnPinning),
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    if (
      search?.BranchIds &&
      Array.isArray(search?.BranchIds) &&
      search?.BranchIds?.length > 0
    ) {
      fetchDataInventory();
    }
  }, [search?.BranchIds]);

  useEffect(() => {
    if (debounceSearchItemCode.length > 3) {
      fetchDataItem();
    }
  }, [debounceSearchItemCode]);

  useEffect(() => {
    fetchDataCatSegment4d();

    // if (debouncedCatSegment4d.length === 0) {
    //   fetchDataCatSegment5e();
    // }
  }, [debouncedCatSegment4d]);

  useEffect(() => {
    fetchDataCatSegment5e();
  }, [debouncedCatSegment5e, search.ListMaChung]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    // getRowId: (row) => row.maCtkm,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: setColumnPinning,
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconFileExport size={14} />}
            onClick={() => handleExportExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate ?? "")
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "startDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate ?? "")
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "endDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              leftSection={<IconBrandMedium color="#15aabf" />}
              searchable
              clearable
              data={dataBranchSelect}
              value={search?.BranchIds}
              onClick={() => {
                if (dataBranchSelect.length === 0) {
                  fetchDataBranch();
                }
              }}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "BranchIds", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Kho"
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              searchable
              clearable
              data={dataInventorySelect}
              value={search?.InvCode}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "InvCode", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã sản phẩm"
              leftSection={<IconBarcode color="#15aabf" />}
              clearable
              searchable
              searchValue={searchItemCode}
              onSearchChange={(e) => {
                setSearchItemCode(e);
              }}
              data={dataItemCodeSelect}
              value={search?.ItemCode}
              onChange={(e) => {
                changeSearchValue(e ? e : [], "ItemCode", setSearch);
              }}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chờ nhập"
              data={[
                { label: "Có chờ nhập", value: "true" },
                { label: "Không chờ nhập", value: "false" },
              ]}
              leftSection={<IconTransferIn color="#15aabf" />}
              value={search?.HasCN}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "HasCN", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chờ xuất"
              data={[
                { label: "Có chờ xuất", value: "true" },
                { label: "Không chờ xuất", value: "false" },
              ]}
              leftSection={<IconTransferOut color="#15aabf" />}
              value={search?.HasCX}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "HasCX", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã chủng"
              leftSection={<IconBarcode color="#15aabf" />}
              clearable
              searchable
              searchValue={searchCatSegment4d}
              onSearchChange={(e) => {
                setSearchCatSegment4d(e);
              }}
              data={dataCatSegment4d}
              value={search?.ListMaChung}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "ListMaChung", setSearch)
              }
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã nhóm"
              leftSection={<IconBarcode color="#15aabf" />}
              clearable
              searchable
              searchValue={searchCatSegment5e}
              onSearchChange={(e) => {
                setSearchCatSegment5e(e);
              }}
              data={dataCatSegment5e}
              value={search?.ListMaNhom}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "ListMaNhom", setSearch)
              }
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ReportGeneralInventory;
